module.exports = __webpack_public_path__ + "static/media/SDFSA_8-845w.ba8c1247.jpg";